export default {
  tradeInBanner: {
    id: 'product_banner_trade_in',
    defaultMessage: 'Get up to $990 for your trade-in!',
  },
}
